const GridSkeleton = () => (
  <div className="w-full bg-dark animate-pulse rounded-lg">
    <div className="mx-2 rounded-md mt-3 mb-2 py-2 w-32 bg-secondary" />
    <div className="mx-2 rounded-md py-2 mb-3 w-16 bg-secondary" />
  </div>
);

export default GridSkeleton;
